import { Component, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validators } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

import { Subject } from 'rxjs';
import { SelectBoxModel } from 'src/app/model';
import { GeneralService } from 'src/app/shared/services';

@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectBoxComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SelectBoxComponent
    }
  ]
})
export class SelectBoxComponent implements OnInit, ControlValueAccessor {

  @Input() label: string = "";

  @Input() className: string;

  @Input() options: SelectBoxModel[];

  @Input() appearance: MatFormFieldAppearance = 'fill';

  @Input() validator: boolean = false;

  @Input() formSubmit: boolean = false;

  @Output() valueChanged = new Subject<string>();

  get required(): boolean {
    return this.formControl?.hasValidator(Validators.required) ?? false;
  }

  // Control Value Accessor
  touched = false;
  disabled = false;
  validationStatus: ValidationErrors | null;
  value: string = "";
  formControl: AbstractControl;

  constructor(
    public generalService: GeneralService
  ) { }

  ngOnInit(): void { }

  /**
   * Determines whether selection change on
   * @param option
   */
  onSelectionChange(option: string) {
    this.valueChanged?.next(option);
    this.value = option;
    this.onChange(this.value);
  }

  onChange: Function;

  onTouched = () => {};

  /**
   * Writes value
   * @param value
   */
  writeValue(value: string) {
    this.value = value;
  }

  /**
   * Registers on change
   * @param onChange
   */
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  /**
   * Registers on touched
   * @param onTouched
   */
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  /**
   * Marks as touched
   */
  markAsTouched() {    
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  /**
   * Sets disabled state
   * @param disabled
   */
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  /**
   * Validates select box component
   * @param control
   * @returns validate
   */
  validate(control: AbstractControl): ValidationErrors | null {
    this.formControl = control;
    this.validationStatus = null;
    return this.validationStatus;
  }

}
